import { CanActivateFn, Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { StorageService } from './storage.service';
import { EnvironmentService } from '../../../environments/environment.service';
import { APP_CONSTANTS } from '../constants/app-constants';
import { PermissionService } from './permission.service';

@Injectable({
  providedIn: 'root',
})
export class authService {
  //   inventory: {
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //     plasticwares: {
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //     glasswares: {
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //     purification: {
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //     vectors: {
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //     constructs: {
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //     paratope: {
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //     oligos: {
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //     antigens: {
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //     library: {
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //     freezer: {
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //     refrigerator: {
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //     shelves: {
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //     instruments: {
  //       master: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //       item: {
  //         view: true,
  //         add: true,
  //         edit: true,
  //         delete: true,
  //         bulkUpload: true,
  //   project: {
  //       project_initiation: {
  //         add: true,
  //         edit: true,
  //         view: true,
  //         delete: true,
  //       project_initiation: {
  //         add: true,
  //         edit: true,
  //         view: true,
  //         delete: true,
  //       project_workflow: {
  //         add: true,
  //         edit: true,
  //         view: true,
  //         delete: true,
  //       project_initiation: {
  //         add: true,
  //         edit: true,
  //         view: true,
  //         delete: true,
  //       project_workflow: {
  //         add: true,
  //         edit: true,
  //         view: true,
  //         delete: true,
  //       project_initiation: {
  //         add: true,
  //         edit: true,
  //         view: true,
  //         delete: true,
  //       project_workflow: {
  //         add: true,
  //         edit: true,
  //         view: true,
  //         delete: true,
  //       project_initiation: {
  //         add: true,
  //         edit: true,
  //         view: true,
  //         delete: true,
  //       project_workflow: {
  //         add: true,
  //         edit: true,
  //         view: true,
  //         delete: true,
  //       project_initiation: {
  //         add: true,
  //         edit: true,
  //         view: true,
  //         delete: true,
  //       project_workflow: {
  //         add: true,
  //         edit: true,
  //         view: true,
  //         delete: true,
  //       project_initiation: {
  //         add: true,
  //         edit: true,
  //         view: true,
  //         delete: true,
  //       project_workflow: {
  //         add: true,
  //         edit: true,
  //         view: true,
  //         delete: true,
  //       project_initiation: {
  //         add: true,
  //         edit: true,
  //         view: true,
  //         delete: true,
  //       project_workflow: {
  //         add: true,
  //         edit: true,
  //         view: true,
  //         delete: true,
  //   vendors: {
  //     view: true,
  //     add: true,
  //     edit: true,
  //     delete: true,
  //   protocols: {
  //     view: true,
  //     add: true,
  //     edit: true,
  //     delete: true,
  //     approve: true,
  //   settings: {
  //     user: {
  //       view: true,
  //       add: true,
  //       edit: true,
  //       delete: true,
  //     role: {
  //       view: true,
  //       add: true,
  //       edit: true,
  //       delete: true,

  constructor(private storageService: StorageService) {}

  public setUserInfo(userData: any) {
    this.storageService.set('access_token', userData?.access_token);
    this.storageService.set('refresh_token', userData?.refresh_token);
    this.storageService.set('profile', userData);
  }

  public getUserInfo() {
    let profile;
    try {
      profile = this.storageService.get('profile');
    } catch (_) {
      console.error('Something went wrong with storage!');
    }
    return profile ?? null;
  }

  public deleteUserInfo() {
    this.storageService.remove('access_token');
    this.storageService.remove('refresh_token');
    this.storageService.remove('profile');
  }

  getPermissions() {
    const profile = this.getUserInfo();
    if (profile?.permissions) {
      return profile?.permissions;
    }
    return {};
  }

  routePermission(group: string, route: string = '', classification: string = '') {
    const permissions: any = this.getPermissions();
    let permission = permissions[group];
    if (route) {
      permission = permission[route];
      if (classification) {
        permission = permission[classification];
      }
    }
    return permission;
  }

  hasActionPermission(action: string, route: string, group: string): boolean {
    const permissions: any = this.getPermissions();
    return permissions[group]?.[route]?.[action] ? true : false;
  }
}

export const authGuard: CanActivateFn = (_route, _state) => {
  const router = inject(Router);
  return inject(authService).getUserInfo() === null ? router.navigateByUrl('/login') : true;
};

export const loginGuard: CanActivateFn = (_route, _state) => {
  if (inject(authService).getUserInfo()) {
    const clientId = inject(EnvironmentService).clientId;
    inject(Router).navigate([clientId === '2' ? '/projects' : '/inventory']);
    return false;
  } else {
    return true;
  }
};

export const permissionGuard: CanActivateFn = (route, _state) => {
  const clientId = inject(EnvironmentService).clientId;
  const requestedRoute = route.routeConfig?.path;
  if (clientId == '3' && requestedRoute !== 'settings') {
    inject(Router).navigateByUrl('manus-bio-experiments');
    return false;
  }
  const menu_items = inject(authService).getUserInfo()?.menu_item;
  if (menu_items?.includes(requestedRoute) || menu_items?.includes(requestedRoute?.split('/')[0])) {
    return true;
  } else {
    inject(Router).navigateByUrl('access-denied');
    return false;
  }
};

export const hasRoutePermission = (group: string, subGroup: string = ''): CanActivateFn => {
  return (route, state) => {
    const autherizationService = inject(authService);
    const permissionService = inject(PermissionService);
    const router = inject(Router);

    switch (group) {
      case APP_CONSTANTS.PERMISSIONS.MENU.INVENTORY:
        const segments = state.url.split('/');
        const lastSegment = segments[segments.length - 1];
        if (lastSegment && autherizationService.routePermission(group, lastSegment)) {
          permissionService.setPermissions(autherizationService.routePermission(group, lastSegment));
          return true; // Access granted
        }
        break;
      case APP_CONSTANTS.PERMISSIONS.MENU.PROJECTS:
        if (autherizationService.routePermission(group)) {
          permissionService.setPermissions(autherizationService.routePermission(group));
          switch (subGroup) {
            case APP_CONSTANTS.PROJECTS.SIMISCO_PROJECT_CODE.PURIFIEDssDNA:
              if (
                autherizationService.routePermission(group, APP_CONSTANTS.PROJECTS.SIMISCO_PROJECT_CODE.PURIFIEDssDNA, APP_CONSTANTS.PERMISSIONS.CLASSIFICATIONS.PROJECT_WORKFLOW)
              ) {
                return true; // Access granted
              }
              break;
            case APP_CONSTANTS.PROJECTS.SIMISCO_PROJECT_CODE.ECS:
              if (autherizationService.routePermission(group, APP_CONSTANTS.PROJECTS.SIMISCO_PROJECT_CODE.ECS, APP_CONSTANTS.PERMISSIONS.CLASSIFICATIONS.PROJECT_WORKFLOW)) {
                return true; // Access granted
              }
              break;
            case APP_CONSTANTS.PROJECTS.SIMISCO_PROJECT_CODE.SEP:
              if (autherizationService.routePermission(group, APP_CONSTANTS.PROJECTS.SIMISCO_PROJECT_CODE.SEP, APP_CONSTANTS.PERMISSIONS.CLASSIFICATIONS.PROJECT_WORKFLOW)) {
                return true; // Access granted
              }
              break;
            case APP_CONSTANTS.PROJECTS.SIMISCO_PROJECT_CODE.SASA:
              if (autherizationService.routePermission(group, APP_CONSTANTS.PROJECTS.SIMISCO_PROJECT_CODE.SASA, APP_CONSTANTS.PERMISSIONS.CLASSIFICATIONS.PROJECT_WORKFLOW)) {
                return true; // Access granted
              }
              break;
            case APP_CONSTANTS.PROJECTS.SIMISCO_PROJECT_CODE.APCE:
              if (autherizationService.routePermission(group, APP_CONSTANTS.PROJECTS.SIMISCO_PROJECT_CODE.APCE, APP_CONSTANTS.PERMISSIONS.CLASSIFICATIONS.PROJECT_WORKFLOW)) {
                return true; // Access granted
              }
              break;
            case APP_CONSTANTS.PROJECTS.SIMISCO_PROJECT_CODE.DNASEQ:
              if (autherizationService.routePermission(group, APP_CONSTANTS.PROJECTS.SIMISCO_PROJECT_CODE.DNASEQ, APP_CONSTANTS.PERMISSIONS.CLASSIFICATIONS.PROJECT_WORKFLOW)) {
                return true; // Access granted
              }
              break;
            case APP_CONSTANTS.PROJECTS.SIMISCO_PROJECT_CODE.CONSTRANS:
              if (autherizationService.routePermission(group, APP_CONSTANTS.PROJECTS.SIMISCO_PROJECT_CODE.CONSTRANS, APP_CONSTANTS.PERMISSIONS.CLASSIFICATIONS.PROJECT_WORKFLOW)) {
                return true; // Access granted
              }
              break;
            case APP_CONSTANTS.PROJECTS.SIMISCO_PROJECT_CODE.PROTEINPURIFICATION:
              if (autherizationService.routePermission(group, APP_CONSTANTS.PROJECTS.SIMISCO_PROJECT_CODE.PROTEINPURIFICATION, APP_CONSTANTS.PERMISSIONS.CLASSIFICATIONS.PROJECT_WORKFLOW)) {
                return true; // Access granted
              }
              break;
            default:
              return true; // Access granted
          }
        }
        break;
      case APP_CONSTANTS.PERMISSIONS.MENU.VENDOR:
        if (autherizationService.routePermission(group)) {
          permissionService.setPermissions(autherizationService.routePermission(group));
          return true; // Access granted
        }
        break;
      case APP_CONSTANTS.PERMISSIONS.MENU.PROTOCOL:
        if (autherizationService.routePermission(group)) {
          permissionService.setPermissions(autherizationService.routePermission(group));
          return true; // Access granted
        }
        break;
      case APP_CONSTANTS.PERMISSIONS.MENU.SETTINGS:
        if (autherizationService.routePermission(group)) {
          permissionService.setPermissions(autherizationService.routePermission(group));
          return true; // Access granted
        }
        break;
    }
    router.navigateByUrl('access-denied');
    return false; // Access denied by default
  };
};
